export default `<svg 
 aria-hidden="true" aria-label="panels" 
width="24" height="24" viewBox="0 0 24 24" fill="none" >
<path d="M4 5.77778V18.2222C4 19.2 4.79111 20 5.77778 20H11.1111V4H5.77778C4.79111 4 4 4.8 4 5.77778Z" fill="#111111"/>
<path d="M12.8889 20V4H15.5556V20H12.8889Z" fill="#111111"/>
<path d="M17.3334 4H18C19.1046 4 20 4.89543 20 6V18C20 19.1046 19.1046 20 18 20H17.3334V4Z" fill="#111111"/>
</svg>
`;
